document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-clean-rich-text]').forEach((container) => {
    container.querySelectorAll('[style], [face], [size], [color], [bgcolor], [align]').forEach((element) => {
      ['style', 'face', 'size', 'color', 'bgcolor', 'align'].forEach((attribute) => element.removeAttribute(attribute));
    });
  });

  const analyticsEnabled = document.body.dataset.customAnalytics === 'true';
  const campaignContext = () => {
    const params = new URLSearchParams(window.location.search);
    return ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].reduce((context, key) => {
      const value = params.get(key);
      if (value) context[key] = value.slice(0, 200);
      return context;
    }, {});
  };
  const publishAndanzasEvent = (name, data = {}) => {
    if (!analyticsEnabled || !name.startsWith('andanzas:')) return;
    const payload = { ...data, ...campaignContext() };
    try {
      const publication = window.Shopify?.analytics?.publish?.(name, payload);
      publication?.catch?.(() => {});
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...payload });
    } catch (_) {
      // Analytics must never interrupt navigation or storefront interactions.
    }
  };

  document.querySelectorAll('[data-analytics-search]').forEach((form) => {
    form.addEventListener('submit', () => {
      const query = form.elements.q?.value.trim();
      if (!query) return;
      publishAndanzasEvent('andanzas:search_submitted', {
        query_length: Math.min(query.length, 200),
        source: form.dataset.analyticsSearch
      });
    });
  });

  document.querySelectorAll('[data-analytics-search-results]').forEach((summary) => {
    publishAndanzasEvent('andanzas:search_results_viewed', {
      query_length: Math.min((summary.dataset.searchQuery || '').length, 200),
      results_count: Number(summary.dataset.resultsCount) || 0
    });
  });

  document.querySelectorAll('[data-analytics-view]').forEach((element) => {
    publishAndanzasEvent(element.dataset.analyticsView, {
      id: element.dataset.analyticsId,
      label: element.dataset.analyticsLabel
    });
  });

  document.querySelector('[data-form-success]')?.focus();

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-analytics-event]');
    if (!target) return;
    publishAndanzasEvent(target.dataset.analyticsEvent, {
      id: target.dataset.analyticsId,
      label: target.dataset.analyticsLabel,
      action: target.dataset.analyticsAction || 'open'
    });
  });

  const pickupRequests = new WeakMap();
  const loadPickupAvailability = async (container, variantId) => {
    if (!container || !variantId) return;
    pickupRequests.get(container)?.abort();
    const request = new AbortController();
    pickupRequests.set(container, request);
    container.setAttribute('aria-busy', 'true');
    const rootUrl = container.dataset.rootUrl || '/';
    try {
      const response = await fetch(`${rootUrl}variants/${variantId}/?section_id=pickup-availability`, { signal: request.signal });
      if (!response.ok) throw new Error(`Pickup availability request failed: ${response.status}`);
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      container.innerHTML = page.querySelector('.shopify-section')?.innerHTML || '';
      container.dataset.variantId = variantId;
    } catch (error) {
      if (error.name !== 'AbortError') container.innerHTML = '';
    } finally {
      if (pickupRequests.get(container) === request) container.removeAttribute('aria-busy');
    }
  };

  document.querySelectorAll('[data-pickup-availability]').forEach((container) => {
    loadPickupAvailability(container, container.dataset.variantId);
  });

  document.querySelectorAll('[data-discovery-shelf]').forEach((shelf) => {
    const groups = [...shelf.querySelectorAll('[data-discovery-group]')];
    const button = shelf.querySelector('[data-discovery-next]');
    const status = shelf.querySelector('[data-discovery-status]');
    if (!button || groups.length < 2) return;
    let current = Number(shelf.dataset.currentGroup) || 0;
    button.addEventListener('click', () => {
      groups[current].hidden = true;
      current = (current + 1) % groups.length;
      groups[current].hidden = false;
      shelf.dataset.currentGroup = String(current);
      if (status) status.textContent = `${status.dataset.statusLabel} ${current + 1} / ${groups.length}`;
      publishAndanzasEvent('andanzas:discovery_refreshed', {
        shelf_position: current + 1,
        shelf_count: groups.length
      });
    });
  });

  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');

  if (toggle && nav) {
    const closeMenu = () => {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', toggle.dataset.openLabel);
    };

    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
    });
    nav.addEventListener('click', (event) => {
      if (event.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        closeMenu();
        toggle.focus();
      }
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const root = select.closest('[data-product-root]');
      const price = root?.querySelector('[data-product-price]');
      const priceTemplate = root?.querySelector(`[data-variant-price-template="${option.value}"]`);
      const button = root?.querySelector('[data-add-to-cart]');
      const availability = root?.querySelector('[data-availability]');
      const available = option.dataset.available === 'true';

      if (price && priceTemplate) {
        price.replaceChildren(priceTemplate.content.cloneNode(true));
      }
      if (button) {
        button.disabled = !available;
        button.textContent = available ? select.dataset.addLabel : select.dataset.soldLabel;
      }
      if (availability) {
        availability.innerHTML = available
          ? `<span aria-hidden="true">●</span> ${option.dataset.availabilityLabel || select.dataset.availableLabel}`
          : `<span aria-hidden="true">×</span> ${select.dataset.referenceLabel}`;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
      loadPickupAvailability(root?.querySelector('[data-pickup-availability]'), option.value);
    });
  });

  document.querySelectorAll('.product__form').forEach((form) => {
    form.addEventListener('submit', () => {
      const button = form.querySelector('[data-add-to-cart]');
      if (!button || button.disabled) return;
      button.dataset.restingLabel = button.textContent.trim();
      button.textContent = button.dataset.addingLabel || button.textContent;
      button.classList.add('is-submitting');
      button.setAttribute('aria-busy', 'true');
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const dialog = gallery.closest('[data-product-root]')?.querySelector('[data-gallery-dialog]');
    const triggers = [...gallery.querySelectorAll('[data-gallery-trigger]')];
    const image = dialog?.querySelector('[data-gallery-image]');
    const viewport = dialog?.querySelector('[data-gallery-viewport]');
    const zoom = dialog?.querySelector('[data-gallery-zoom]');
    const caption = dialog?.querySelector('[data-gallery-caption]');
    const count = dialog?.querySelector('[data-gallery-count]');
    const previous = dialog?.querySelector('[data-gallery-previous]');
    const next = dialog?.querySelector('[data-gallery-next]');
    if (!dialog || !image || !viewport || !zoom || !caption || !count || !previous || !next || !triggers.length) return;

    let currentIndex = 0;
    let opener;
    let zoomed = false;
    let panFrame;

    const updateZoomControl = () => {
      zoom.setAttribute('aria-pressed', String(zoomed));
      zoom.textContent = zoomed ? zoom.dataset.zoomOutLabel : zoom.dataset.zoomInLabel;
    };

    const setZoom = (shouldZoom, clientX, clientY) => {
      if (!shouldZoom) {
        zoomed = false;
        viewport.classList.remove('is-zoomed');
        image.style.removeProperty('width');
        image.style.removeProperty('height');
        viewport.scrollTo(0, 0);
        updateZoomControl();
        return;
      }

      if (!image.complete || !image.naturalWidth || !image.naturalHeight) {
        image.addEventListener('load', () => setZoom(true, clientX, clientY), { once: true });
        return;
      }

      const viewportRect = viewport.getBoundingClientRect();
      const fitScale = Math.min(viewport.clientWidth / image.naturalWidth, viewport.clientHeight / image.naturalHeight);
      const fittedWidth = image.naturalWidth * fitScale;
      const fittedHeight = image.naturalHeight * fitScale;
      const fittedLeft = (viewport.clientWidth - fittedWidth) / 2;
      const fittedTop = (viewport.clientHeight - fittedHeight) / 2;
      const anchorX = Number.isFinite(clientX)
        ? Math.min(1, Math.max(0, (clientX - viewportRect.left - fittedLeft) / fittedWidth))
        : 0.5;
      const anchorY = Number.isFinite(clientY)
        ? Math.min(1, Math.max(0, (clientY - viewportRect.top - fittedTop) / fittedHeight))
        : 0.5;
      const enlargedWidth = fittedWidth * 2;
      const enlargedHeight = fittedHeight * 2;

      zoomed = true;
      viewport.classList.add('is-zoomed');
      image.style.width = `${enlargedWidth}px`;
      image.style.height = `${enlargedHeight}px`;
      updateZoomControl();

      requestAnimationFrame(() => {
        viewport.scrollLeft = (anchorX * enlargedWidth) - (viewport.clientWidth / 2);
        viewport.scrollTop = (anchorY * enlargedHeight) - (viewport.clientHeight / 2);
      });

      publishAndanzasEvent('andanzas:product_image_zoomed', {
        product_id: gallery.dataset.productId,
        image_position: currentIndex + 1
      });
    };

    const showImage = (index) => {
      setZoom(false);
      currentIndex = (index + triggers.length) % triggers.length;
      const trigger = triggers[currentIndex];
      image.src = trigger.dataset.gallerySrc;
      image.alt = trigger.dataset.galleryAlt || '';
      image.classList.remove('is-changing');
      void image.offsetWidth;
      image.classList.add('is-changing');
      caption.textContent = trigger.dataset.galleryCaption || '';
      caption.hidden = !trigger.dataset.galleryCaption;
      count.textContent = `${currentIndex + 1} / ${triggers.length}`;
      previous.disabled = triggers.length < 2;
      next.disabled = triggers.length < 2;
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        opener = trigger;
        showImage(index);
        dialog.showModal();
        dialog.querySelector('[data-gallery-close]')?.focus();
      });
    });

    zoom.addEventListener('click', () => setZoom(!zoomed));
    image.addEventListener('click', (event) => setZoom(!zoomed, event.clientX, event.clientY));
    viewport.addEventListener('pointermove', (event) => {
      if (!zoomed || event.pointerType !== 'mouse') return;
      cancelAnimationFrame(panFrame);
      panFrame = requestAnimationFrame(() => {
        const rect = viewport.getBoundingClientRect();
        const horizontalProgress = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
        const verticalProgress = Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height));
        viewport.scrollLeft = horizontalProgress * (viewport.scrollWidth - viewport.clientWidth);
        viewport.scrollTop = verticalProgress * (viewport.scrollHeight - viewport.clientHeight);
      });
    });
    previous.addEventListener('click', () => showImage(currentIndex - 1));
    next.addEventListener('click', () => showImage(currentIndex + 1));
    dialog.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(currentIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(currentIndex + 1);
      }
      if (event.key === '+' || event.key === '=') {
        event.preventDefault();
        setZoom(true);
      }
      if (event.key === '-' || event.key === '0') {
        event.preventDefault();
        setZoom(false);
      }
    });
    dialog.addEventListener('close', () => {
      setZoom(false);
      opener?.focus();
    });
  });

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    if (!section.dataset.url || section.querySelector('.page-width')) return;
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const recommendations = html.querySelector('[data-product-recommendations]');
      if (recommendations?.innerHTML.trim()) section.innerHTML = recommendations.innerHTML;
    } catch (error) {
      console.warn('No se pudieron cargar los libros relacionados.', error);
    }
  });

  document.querySelectorAll('[data-auto-submit]').forEach((control) => {
    control.addEventListener('change', () => control.form?.requestSubmit());
  });

  document.querySelectorAll('[data-collection-browser]').forEach((browser) => {
    const panel = browser.querySelector('[data-collection-filters]');
    const toggle = browser.querySelector('[data-filters-toggle]');
    if (!panel || !toggle) return;

    const mobileViewport = window.matchMedia('(max-width: 900px)');
    const closeControls = browser.querySelectorAll('[data-filters-close]');
    let opener = null;

    const isOpen = () => panel.classList.contains('is-open');
    const focusableElements = () => Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'));

    const closeFilters = (restoreFocus = true) => {
      panel.classList.remove('is-open');
      browser.classList.remove('filters-are-open');
      document.body.classList.remove('collection-filters-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (mobileViewport.matches) panel.setAttribute('aria-hidden', 'true');
      if (restoreFocus && opener instanceof HTMLElement) opener.focus();
    };

    const openFilters = () => {
      if (!mobileViewport.matches) return;
      opener = document.activeElement;
      panel.classList.add('is-open');
      browser.classList.add('filters-are-open');
      document.body.classList.add('collection-filters-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.querySelector('[data-filters-close]')?.focus();
    };

    const synchronizeViewport = () => {
      if (mobileViewport.matches) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        if (!isOpen()) panel.setAttribute('aria-hidden', 'true');
      } else {
        closeFilters(false);
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
        panel.removeAttribute('aria-hidden');
      }
    };

    toggle.addEventListener('click', openFilters);
    closeControls.forEach((control) => control.addEventListener('click', () => closeFilters()));
    panel.addEventListener('keydown', (event) => {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeFilters();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = focusableElements();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    mobileViewport.addEventListener('change', synchronizeViewport);
    synchronizeViewport();
  });

  document.querySelectorAll('[data-cart-page]').forEach((cartPage) => {
    const cartForm = cartPage.querySelector('#CartForm');
    const updateButton = cartForm?.querySelector('[data-cart-update]');
    let updateTimer;
    const updateCart = () => {
      window.clearTimeout(updateTimer);
      cartPage.classList.add('is-cart-updating');
      cartPage.setAttribute('aria-busy', 'true');
      updateTimer = window.setTimeout(() => updateButton?.click(), 300);
    };

    cartPage.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.closest('.quantity-stepper')?.querySelector('[data-cart-quantity]');
        if (!input) return;
        const minimum = Number(input.min || 0);
        const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
        input.value = String(Math.min(maximum, Math.max(minimum, Number(input.value || 0) + Number(button.dataset.quantityChange))));
        updateCart();
      });
    });
    cartPage.querySelectorAll('[data-cart-quantity]').forEach((input) => input.addEventListener('change', updateCart));

    const discountForm = cartPage.querySelector('[data-discount-form]');
    const discountInput = discountForm?.querySelector('[data-discount-code]');
    const discountButton = discountForm?.querySelector('[data-apply-discount]');
    const discountError = discountForm?.querySelector('[data-discount-error]');
    const applyDiscount = () => {
      const code = discountInput?.value.trim();
      if (!code) {
        discountError?.removeAttribute('hidden');
        discountInput?.focus();
        return;
      }
      discountError?.setAttribute('hidden', '');
      const rootUrl = discountForm.dataset.rootUrl || '/';
      const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
      const cartDestination = `${rootUrl}cart${previewTheme ? `?preview_theme_id=${encodeURIComponent(previewTheme)}` : ''}`;
      window.location.assign(`${rootUrl}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartDestination)}`);
    };
    discountButton?.addEventListener('click', applyDiscount);
    discountInput?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      applyDiscount();
    });
  });

  document.querySelectorAll('[data-scheduled-invitation]').forEach((invitation) => {
    if (invitation.dataset.designMode === 'true') return;
    const frequency = invitation.dataset.frequency || 'week';
    const storageKey = `andanzas-invitation:${invitation.dataset.invitationId}`;
    const now = Date.now();
    const intervals = { day: 86400000, week: 604800000 };
    let shouldShow = true;
    try {
      if (frequency === 'session') shouldShow = sessionStorage.getItem(storageKey) !== 'seen';
      if (intervals[frequency]) shouldShow = now - Number(localStorage.getItem(storageKey) || 0) >= intervals[frequency];
    } catch (_) {
      // Storage can be unavailable in private contexts; the invitation remains usable.
    }
    if (!shouldShow) return;

    const reveal = () => {
      invitation.hidden = false;
      try {
        if (frequency === 'session') sessionStorage.setItem(storageKey, 'seen');
        if (intervals[frequency]) localStorage.setItem(storageKey, String(Date.now()));
      } catch (_) {}
      publishAndanzasEvent('andanzas:campaign_viewed', {
        id: invitation.dataset.invitationId,
        presentation: invitation.classList.contains('scheduled-invitation--tray') ? 'tray' : 'inline'
      });
    };
    const delay = invitation.classList.contains('scheduled-invitation--tray') ? Number(invitation.dataset.delay || 0) * 1000 : 0;
    window.setTimeout(reveal, delay);

    invitation.querySelector('[data-invitation-close]')?.addEventListener('click', () => {
      invitation.hidden = true;
    });
    invitation.querySelector('[data-copy-coupon]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const code = button.dataset.copyCoupon;
      const status = invitation.querySelector('[data-coupon-status]');
      try {
        await navigator.clipboard.writeText(code);
      } catch (_) {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.className = 'visually-hidden';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      }
      button.textContent = button.dataset.copiedLabel;
      if (status) status.textContent = button.dataset.copiedLabel;
      window.setTimeout(() => {
        button.textContent = button.dataset.copyLabel;
        if (status) status.textContent = '';
      }, 2200);
    });
  });

  document.querySelectorAll('[data-predictive-search]').forEach((search) => {
    const input = search.querySelector('[data-predictive-input]');
    const results = search.querySelector('[data-predictive-results]');
    const form = input?.form;
    if (!input || !results || !search.dataset.url) return;

    let request;
    let timer;
    const close = () => {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };
    const open = () => {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      request?.abort();
      const terms = input.value.trim();
      if (terms.length < 2) {
        close();
        return;
      }
      timer = window.setTimeout(async () => {
        request = new AbortController();
        const params = new URLSearchParams({
          q: terms,
          'resources[type]': 'product',
          'resources[limit]': '6',
          'resources[options][unavailable_products]': 'last',
          'resources[options][fields]': 'title,product_type,variants.title,vendor',
          section_id: 'predictive-search'
        });
        try {
          const response = await fetch(`${search.dataset.url}?${params}`, { signal: request.signal });
          if (!response.ok) return;
          const documentFragment = document.createElement('div');
          documentFragment.innerHTML = await response.text();
          const content = documentFragment.querySelector('.shopify-section')?.innerHTML || documentFragment.innerHTML;
          results.innerHTML = content;
          open();
        } catch (error) {
          if (error.name !== 'AbortError') close();
        }
      }, 250);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key) || results.hidden) return;
      const links = [...results.querySelectorAll('a')];
      if (!links.length) return;
      event.preventDefault();
      (event.key === 'ArrowDown' ? links[0] : links.at(-1)).focus();
    });

    results.addEventListener('keydown', (event) => {
      if (!['ArrowDown', 'ArrowUp', 'Escape'].includes(event.key)) return;
      const links = [...results.querySelectorAll('a')];
      const current = links.indexOf(document.activeElement);
      if (event.key === 'Escape') {
        close();
        input.focus();
        return;
      }
      event.preventDefault();
      const next = event.key === 'ArrowDown' ? current + 1 : current - 1;
      if (next < 0 || next >= links.length) input.focus();
      else links[next].focus();
    });

    document.addEventListener('click', (event) => {
      if (!search.contains(event.target)) close();
    });
    form?.addEventListener('submit', (event) => {
      if (input.value.trim()) return;
      event.preventDefault();
      input.focus();
    });
  });

  document.querySelectorAll('.nav-item').forEach((item) => {
    item.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        item.open = false;
        item.querySelector('summary')?.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!item.contains(event.target)) item.open = false;
    });
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-add-to-cart].is-submitting').forEach((button) => {
      button.textContent = button.dataset.restingLabel || button.textContent;
      button.classList.remove('is-submitting');
      button.removeAttribute('aria-busy');
    });
  });
});
